import apiClient from "./client";

export type AdminActivityAction = "created" | "updated" | "deactivated";

export type AdminActivityEntityType =
  | "lender"
  | "user"
  | "los-integration"
  | "intelligent-ordering";

export type AdminActivityActor =
  | {
      type: "user";
      id: string;
      displayName: string;
    }
  | {
      type: "system";
      displayName: "System";
    };

export interface AdminActivityEntity {
  type: AdminActivityEntityType;
  id: string;
  displayName?: string;
}

export interface AdminActivityLender {
  id: string;
  displayName?: string;
}

export interface AdminActivity {
  uuid: string;
  occurredAt: string;
  actor: AdminActivityActor;
  entity: AdminActivityEntity;
  lenders: AdminActivityLender[];
  action: AdminActivityAction;
}

export interface RecentAdminActivityResponse {
  items: AdminActivity[];
  total: number;
  offset: number;
  limit: number;
}

export interface RecentAdminActivityParams {
  offset: number;
  limit: number;
}

export async function getRecentAdminActivity(
  params: RecentAdminActivityParams
): Promise<RecentAdminActivityResponse> {
  const response = await apiClient.get<RecentAdminActivityResponse>(
    "/oms/activity-log/recent",
    { params }
  );
  return response.data;
}
